import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import ProductDetails from './product-details';
import SaleMessage from './sale-message';

class Component extends BaseComponent {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.requireState(this.props.upc);
    }

    render({ message, description, product }) {
        if (!description) {
            return (
                <subscription-teeup />
            );
        }

        return (
            <subscription-teeup>
                <p class='price'>
                    { product.price && product.price.usd.current < product.price.usd.original &&
                    <s>${ product.price.usd.original.toFixed(2) }</s>
                    }
                    { product.price &&
                    <span>${ product.price.usd.current.toFixed(2) }</span>
                    }
                </p>
                <header>
                    <SaleMessage />
                    <img class='product-logo'
                      alt='subscription'
                      src='https://gfx.tarot.com/images/site/tarot/daily-reflection-tarot-redux/icon.svg'
                    />
                    <h1 class='fancy-title'>{ description.product_name }</h1>
                    <ProductDetails summary={description.medium_description} details={description.long_description} />
                </header>
                { message &&
                <div class='marketing-message' dangerouslySetInnerHTML={{__html: message}} />
                }
                <form onSubmit={(e)=> this.submit(e)}>
                    <div class='button-container'>
                        <button class='button button-warning'>
                            { product.submitting ? 'submitting…' : 'Purchase subscription' }
                        </button>
                        { product.error &&
                        <p class='error'>{ product.error }</p>
                        }
                    </div>
                </form>

            </subscription-teeup>
        );
    }

    submit(e) {
        e.preventDefault();
        this.props.submit();
    }
}

const mapStateToProps = (state) => ({
    message: state.product.marketing_message,
    description: state.product.description,
    product: state.product,
});

const mapDispatchToProps = (dispatch) => ({
    requireState: (upc) => dispatch({ type: 'subscription:init', payload: upc }),
    submit: () => dispatch({type: 'product:submit'}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);





// WEBPACK FOOTER //
// ./app/components/subscription-teeup.js